import { MenuProps } from 'components/Menu/Types'
import { Menu } from 'components/Menu/Menu'
import { Item, Section } from '@react-stately/collections'
import { Key } from 'react'
import { observer } from 'mobx-react-lite'
import { useAlmanacEditorState } from 'stores/EditorState'
import { useSetFontSize } from 'common/Prose/Toolbar/components/Format/components/utils/changeFontSize'

export const sizes = [8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 32, 36]

export const FontSizeSubMenu = observer(
  ({ onAction, menuType = 'dropdown' }: Pick<MenuProps<any>, 'menuType' | 'onAction'>) => {
    const editorState = useAlmanacEditorState()
    const { activeFontSizes } = editorState || {
      activeFontSizes: new Set<number>(),
    }

    const setFontSize = useSetFontSize()

    const handleAction = (action: Key) => {
      onAction?.(action)
      setFontSize(parseInt(action as string, 10))
    }

    return (
      <Menu
        onAction={handleAction}
        menuType={menuType}
        selectedKeys={[...activeFontSizes].map((size) => size.toString())}
        selectionMode="multiple"
        aria-label="Font Size"
      >
        <Section>
          {sizes.map((size) => {
            return <Item key={size.toString()}>{size}</Item>
          })}
        </Section>
      </Menu>
    )
  },
)
